import { render, staticRenderFns } from "./CoachingSecondarySubscription.vue?vue&type=template&id=87723ade&scoped=true&"
import script from "./CoachingSecondarySubscription.vue?vue&type=script&lang=js&"
export * from "./CoachingSecondarySubscription.vue?vue&type=script&lang=js&"
import style0 from "./CoachingSecondarySubscription.vue?vue&type=style&index=0&id=87723ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87723ade",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VCheckbox,VCol,VDataTable,VIcon,VMenu,VRow,VTextField,VTreeview})
